import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'app/shared/shared.module';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AuthGuard, PrepareGuard, PendingChangesGuard } from 'app/core/core.module';
import { BasicLayoutComponent } from 'app/common/layouts/basicLayout.component';
import { InvoiceOrderDialogComponent } from './invoice-order-dialog/invoice-order-dialog.component';
import { InvoiceHistoryComponent } from './invoice-history/invoice-history.component';
import { InvoiceDetailComponent } from './invoice-detail/invoice-detail.component';
import { PicturesEntryComponent } from 'app/pictures/pictures-entry/pictures-entry.component';
import { PaymentOverviewComponent } from 'app/payments/payment-overview/payment-overview.component';
import { InvoiceSearchComponent } from './invoice-search/invoice-search.component';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        RouterModule.forChild([
            {
                path: 'invoices',
                component: BasicLayoutComponent,
                children: [
                    { path: '', redirectTo: 'search', pathMatch: 'full' },
                    { path: 'open', component: PaymentOverviewComponent, data: { title: 'Open Invoices' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'search', component: InvoiceSearchComponent, data: { title: 'Recent Invoices' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'history', component: InvoiceHistoryComponent, data: { title: 'Invoice History' }, canActivate: [AuthGuard, PrepareGuard] },
                    {
                        path: ':id',
                        component: InvoiceDetailComponent,
                        data: { title: 'Invoice Detail' },
                        canActivate: [AuthGuard, PrepareGuard],
                        canDeactivate: [PendingChangesGuard],
                    },
                ],
            },
        ]),
    ],
    declarations: [InvoiceSearchComponent, InvoiceOrderDialogComponent, InvoiceHistoryComponent, InvoiceDetailComponent, PaymentOverviewComponent],
})
export class InvoicesModule {}
